
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import CharacterCounter from './CharacterCounter';
import { cn } from '@/lib/utils';
import { australianLocations } from '@/components/company/CompanyFormSchema';

interface TextInputFieldProps {
  id: string;
  name: string;
  label: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  readOnly?: boolean;
  hideCounter?: boolean;
  charCount?: number;
  maxChars?: number;
  isLocation?: boolean;
  onSelectChange?: (value: string) => void;
}

const TextInputField = ({
  id,
  name,
  label,
  placeholder,
  value,
  onChange,
  readOnly = false,
  hideCounter = false,
  charCount,
  maxChars,
  isLocation = false,
  onSelectChange
}: TextInputFieldProps) => {
  return (
    <div className="space-y-2">
      <div className="flex justify-between items-center">
        <Label htmlFor={id}>{label}</Label>
        {!hideCounter && charCount !== undefined && maxChars !== undefined && (
          <CharacterCounter current={charCount} max={maxChars} />
        )}
      </div>
      
      {isLocation ? (
        <Select
          value={value}
          onValueChange={onSelectChange}
          disabled={readOnly}
        >
          <SelectTrigger id={id} className="w-full">
            <SelectValue placeholder="Select location" />
          </SelectTrigger>
          <SelectContent>
            {australianLocations.map((location) => (
              <SelectItem key={location} value={location}>
                {location}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <Input
          id={id}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          readOnly={readOnly}
          className={cn(
            "transition-all duration-200 focus-visible:ring-redflags-red/30",
            readOnly && "bg-gray-100"
          )}
        />
      )}
    </div>
  );
};

export default TextInputField;
